export default "__VITE_ASSET__CBdRxjQG__"